import log from 'salvo-lite/log'

class Cart {
    constructor (components) {
        log.debug(this.constructor.name, 'Constructing', components)
        this.components = components
    }

    onInit () {
        let slider = this.components.getComponentsById('cartSlider')
        slider.init()
    }
}

export default Cart



// WEBPACK FOOTER //
// ./src/scripts/pages/Cart.js